const blogs = [
  {
    id: 1,
    date: "2024-12-20",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Estratégias para Maximizar Bônus no Vermelho555",
    descr:
      "Aprenda como aproveitar ao máximo os bônus do Vermelho555 com dicas práticas e eficazes.",
    fullText:
      'Os bônus são uma das maiores vantagens de jogar na plataforma Vermelho555. Para começar, é importante entender os termos e condições de cada oferta. \n\nPlaneje suas apostas com base no valor mínimo necessário para ativar os bônus. Isso ajudará a garantir que você não perca nenhuma oportunidade.\n\nAproveite as promoções sazonais, como o "Pegue um presente do Papai Noel", que oferecem vantagens únicas. \n\nJogue de forma responsável, estabelecendo limites para seu orçamento. Isso permite que você aproveite os jogos sem preocupações.\n\nUse rodadas grátis para explorar novos jogos sem arriscar seu saldo. \n\nMantenha-se atualizado com o blog do Vermelho555 para saber sobre novas promoções e estratégias. \n\nParticipe de programas de fidelidade para acumular pontos e trocá-los por bônus adicionais. \n\nPor fim, lembre-se de se divertir. A experiência de jogar no Vermelho555 deve ser emocionante e agradável.',
  },
  {
    id: 2,
    date: "2024-12-18",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Guia Completo para Jogar Fortune Tiger",
    descr:
      "Descubra como liberar o poder do tigre da fortuna no jogo exclusivo Fortune Tiger.",
    fullText:
      "O Fortune Tiger é um dos jogos mais populares no Vermelho555. Antes de começar, familiarize-se com as regras e a tabela de pagamentos. \n\nDefina sua aposta inicial com base no seu orçamento e no valor mínimo necessário para desbloquear recursos bônus. \n\nAtive rodadas grátis ao conseguir combinações especiais nos rolos. Essas rodadas aumentam suas chances de vitória. \n\nAproveite os multiplicadores de ganhos disponíveis no jogo. Eles podem aumentar significativamente seus prêmios.\n\nMantenha o foco nas combinações vencedoras mais frequentes e ajuste suas apostas conforme necessário. \n\nUtilize o modo de demonstração para testar estratégias antes de apostar dinheiro real. \n\nParticipe de competições dentro do jogo para aumentar a emoção e competir com outros jogadores. \n\nDivirta-se explorando os gráficos impressionantes e a trilha sonora imersiva que fazem do Fortune Tiger uma experiência única.",
  },
  {
    id: 3,
    date: "2024-12-15",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Dicas para Ganhar no Aviator no Vermelho555",
    descr:
      "Melhore seu desempenho no Aviator com nossas dicas e truques especializados.",
    fullText:
      "O Aviator é um jogo de alta adrenalina disponível no Vermelho555. Para começar, escolha seu momento para apostar com cuidado. \n\nEstude as estatísticas das rodadas anteriores para identificar padrões e tendências. \n\nGerencie seu orçamento de forma eficaz, evitando apostas impulsivas ou arriscadas. \n\nUse as rodadas de teste para se familiarizar com o ritmo do jogo antes de apostar dinheiro real. \n\nRetire seus ganhos no momento certo. Esperar demais pode resultar em perdas inesperadas. \n\nAproveite os recursos multijogador para competir com outros jogadores e aprender novas estratégias. \n\nParticipe de eventos exclusivos do Vermelho555 para ganhar prêmios adicionais enquanto joga Aviator. \n\nLembre-se de jogar de forma responsável e aproveitar a experiência emocionante que o Aviator oferece.",
  },
  {
    id: 4,
    date: "2024-12-10",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Por Que Escolher o Vermelho555 para Jogos Online?",
    descr:
      "Entenda os diferenciais do Vermelho555 e descubra porque é a escolha ideal para jogadores online.",
    fullText:
      'O Vermelho555 é mais do que uma plataforma de jogos, é uma experiência completa. \n\nCom uma ampla variedade de jogos, desde slots como Fortune Tiger até jogos de mesa clássicos, há algo para todos. \n\nOs bônus são outro grande atrativo. Ofertas como o "Aproveite o bônus do Papai Noel" tornam cada aposta mais emocionante. \n\nA segurança é uma prioridade no Vermelho555. Com tecnologia de ponta, seus dados estão sempre protegidos. \n\nOs programas de fidelidade recompensam jogadores dedicados com pontos que podem ser trocados por prêmios incríveis. \n\nA plataforma é otimizada para dispositivos móveis, permitindo que você jogue onde e quando quiser. \n\nO suporte ao cliente 24/7 garante que suas dúvidas sejam resolvidas rapidamente. \n\nExplore o blog do Vermelho555 para descobrir dicas, estratégias e as últimas novidades do mundo dos jogos.',
  },
  {
    id: 5,
    date: "2024-12-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Melhores Jogos para Começar no Vermelho555",
    descr:
      "Saiba quais jogos escolher como iniciante no Vermelho555 para uma experiência incrível.",
    fullText:
      "Se você está começando no Vermelho555, existem jogos perfeitos para iniciantes. \n\nOs slots, como Fortune Tiger, são uma ótima escolha para entender a dinâmica de apostas. \n\nJogos de mesa, como blackjack e roleta, oferecem estratégias simples e diversão garantida. \n\nExperimente o Aviator, um jogo dinâmico que mistura sorte e habilidade. \n\nUse o modo de demonstração para aprender as regras sem arriscar seu saldo. \n\nAproveite os bônus de boas-vindas para aumentar seu saldo inicial e explorar mais jogos. \n\nLeia o blog Vermelho555 para dicas de especialistas sobre como começar e se destacar. \n\nParticipe de torneios para ganhar prêmios enquanto aprimora suas habilidades. \n\nDivirta-se explorando a plataforma e descubra seu estilo de jogo preferido.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);
});
